var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-form"},[_c('h3',[_vm._v("Dein Benutzername")]),_c('VueTelegramLogin',{attrs:{"mode":"callback","telegram-login":"teechnikbot"},on:{"callback":_vm.doLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }